import { PARTICIPATING_CONTRACT_STATUSES } from './contractStatus';

// Event participation includes artists registered without a contract.
export const EVENT_PARTICIPANT_STATUSES = new Set<string>([
  ...PARTICIPATING_CONTRACT_STATUSES,
  'manual_participant',
]);

export const isEventParticipantStatus = (status: unknown): boolean =>
  EVENT_PARTICIPANT_STATUSES.has(String(status || '').trim().toLowerCase());
